import React from "react";
import { getFormattedNumber, getYearFromDateStr } from "../utils/textUtils";
import Loader from "../Common/Loader";

// excelExport: true while the Excel file is being generated. City, State, Inv. No, GRN No and GRN Date
// stay on screen (and in the API) but are left out of the downloaded sheet.
const GrnReport = ({ resPacket, loading, excelExport = false }) => {
  const showScreenOnly = !excelExport;
  const getTotalAmount = (_row) => {
    if (_row && !isNaN(_row.taxRate) && !isNaN(_row.amount)) {
      const taxRate = parseFloat(_row.taxRate);
      const amount = parseFloat(_row.amount);
      const tcsRate = parseFloat(_row.tcsRate);
      let taxAmount = (amount * taxRate) / 100;
      return getFormattedNumber(amount + taxAmount + tcsRate);
    } else {
      return "NA";
    }
  };

  if (loading) {
    return <Loader />;
  }

  if (resPacket?.length === 0) {
    return "No Records Found";
  }

  return (
    <div className="customTable"  id="scroll">
      <table className="customTable w-100">
        <thead className="fixed-thead">
          <tr>
            <td>SNO.</td>
            <td>PO NUMBER</td>
            <td>PO DATE</td>
            <td>SUPPLIER NAME</td>
            {showScreenOnly && <td>CITY</td>}
            {showScreenOnly && <td>STATE</td>}
            {showScreenOnly && <td>INV. NO</td>}
            <td>INV. Date</td>
            {showScreenOnly && <td>GRN NO</td>}
            {showScreenOnly && <td>GRN DATE</td>}
            <td>Batch NO</td>
            <td>MFG DATE</td>
            <td>Expiry DATE</td>
            <td>ITEM CODE</td>
            <td>ITEM NAME</td>
            <td>ITEM CATEGORY</td>
            <td>ITEM SUB CATEGORY</td>
            <td className="text-center">QTY</td>
            <td>UOM</td>
            <td className="text-center">ITEM RATE</td>
            <td className="text-center">AMOUNT</td>
            <td className="text-center">TAX RATE</td>
            <td className="text-center">TCS</td>
            <td className="text-center">TOTAL AMOUNT</td>
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {resPacket?.map((row, i) => (
            <tr key={i}>
              <td>{i+1}</td>
              <td className="white-space-pre">{row.purchaseNumber}</td>
              <td className="white-space-pre">{row.purchaseDate}</td>
              <td>{row.supplierName}</td>
              {showScreenOnly && <td>{row.city}</td>}
              {showScreenOnly && <td>{row.state}</td>}
              {showScreenOnly && <td>{row.invNo}</td>}
              <td>{row.invDate}</td>
              {showScreenOnly && <td className="white-space-pre">{row.grnNoBillNumber}</td>}
              {showScreenOnly && <td className="white-space-pre">{row.grnDate}</td>}
              <td>{row.batchNO}</td>
              <td>{row.mfgDate}</td>
              <td>{row.expDate}</td>
              <td>{row.itemCode}</td>
              <td>{row.itemName}</td>
              <td>{row.category}</td>
              <td>{row.subCategory}</td>
              <td className="text-right">{getFormattedNumber(row.qty)}</td>
              <td>{row.uom}</td>
              <td className="text-right">{getFormattedNumber(row.rate)}</td>
              <td className="text-right">{getFormattedNumber(row.amount)}</td>
              <td className="text-right">{getFormattedNumber(row.taxRate)}</td>
              <td className="text-right">{getFormattedNumber(row.tcsRate)}</td>
              <td className="text-right">{getTotalAmount(row)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GrnReport;
